<template>
    <div class="to-top d-i-b p-f">
        <a class="d-i-b" href="javascript:;" @click="scrollTop">
            <img :src="top" alt="">
        </a>
    </div>
</template>
<style lang="less" scoped>
    .to-top {
        right: 0;
        top: 70%;
        z-index: 2;
        a{
            width: 1rem;
            height: 1rem;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                top: 'https://restw-download.vsplay.com/res_tw/activity/twszqy/gw/pc/v2/images/top.png'
            }
        },
        methods: {
            scrollTop() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/components/common/toTop/index.vue